import React from 'react';
import cx from 'classnames';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { LocationDescriptor } from 'history';
import { Optional } from 'types/utilTypes';

import { NavigationLinksWrapper, BadgetWrapper } from './StyledNavigationLinks';
import Icon from 'components/icons/Icon';

type ClickEvent = () => void;

interface LinkProps extends NavLinkProps {
  text: string;
  icon?: string;
  active?: boolean;
  onClick?: ClickEvent;
  target?: string;
  badget?: boolean;
  badgetLabel?: string;
  onLinkClick?: () => void;
}

export type NavigationLinkProps = Optional<LinkProps, 'to'>;

export interface NavigationLinksProps {
  links: Array<NavigationLinkProps>;
  className?: string;
  id?: string;
  onLinkClick?: () => void;
}

const NavigationLinkItem: React.FC<NavigationLinkProps> = props => {
  const {
    text,
    to,
    icon,
    active,
    onClick,
    target,
    badget,
    badgetLabel,
    onLinkClick
  } = props;

  if (to) {
    return (
      <li>
        <NavLink
          to={to as LocationDescriptor}
          target={target}
          className={cx({ active })}
          onClick={() => {
            onLinkClick?.();
          }}
        >
          {icon && <Icon name={icon} />}
          {text}
          {badget && <BadgetWrapper>{badgetLabel}</BadgetWrapper>}
        </NavLink>
      </li>
    );
  }

  if (onClick) {
    return (
      <li>
        <button
          onClick={() => {
            onClick();
            onLinkClick?.();
          }}
        >
          {text}
        </button>
      </li>
    );
  }

  return null;
};

const NavigationLinks: React.FC<NavigationLinksProps> = props => {
  const { links, id, className, onLinkClick: globalOnLinkClick } = props;

  return (
    <NavigationLinksWrapper id={id} className={className}>
      {links.map((item, index) => (
        <NavigationLinkItem
          key={index}
          {...item}
          onLinkClick={() => {
            item.onLinkClick?.();
            globalOnLinkClick?.();
          }}
        />
      ))}
    </NavigationLinksWrapper>
  );
};

export default NavigationLinks;
